export const INIT_USER_DASHBOARD_CONTEXT = {
    id: null,
    name: "",
    role: {
        id: 0,
    }
};
export const INIT_DASHBOARD_CONTEXT = {
    user: { ...INIT_USER_DASHBOARD_CONTEXT },
    userCampusId: 0
};